import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

import BlockTitle from '../BlockTitle'
import Perspective from '../Perspective'
import { _Picture } from '../Perspective/styled'
import Slider from '../Slider'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(136)};
  }
`

export const _BlockTitle = styled(BlockTitle)`
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`

export const _Slider = styled(Slider)`
  overflow: hidden;
  padding-inline: ${pxToRem(16)};
  & .keen-slider[data-keen-slider-disabled] {
    display: flex;
    flex-flow: row;
    gap: ${pxToRem(16)};
  }
  @media ${mq(sizes.desktop)} {
    padding-inline: ${pxToRem(32)};
    & .keen-slider__slide {
      flex: 1 1 0;
    }
  }
`

export const _Perspective = styled(motion.create(Perspective))`
  height: 100%;
  & ${_Picture} {
    height: 100%;
  }
  & img {
    height: 100%;
    object-fit: cover;
  }
`
